import { Environment } from '../config/environment';
import { Log } from '@lightningjs/sdk';
import { BaseSysCalls } from './BaseSysCalls';
import { TizenSysCalls } from './TizenSysCalls';
import { WebSysCalls } from './WebSysCalls';
import { EOSSysCalls } from './EOSSysCalls';

export let SysCalls!: typeof BaseSysCalls;

export function initSyscalls() {
  setSysCalls();
  SysCalls.init();
}

export function setSysCalls(syscalls?: typeof BaseSysCalls) {
  if (syscalls) {
    SysCalls = syscalls;
    return;
  }
  switch (Environment.system) {
    case 'SMARTTV_TIZEN':
      SysCalls = TizenSysCalls;
      return;
    case 'EOS':
      SysCalls = EOSSysCalls;
      return;
    case 'SMARTTV_WEBOS':
    default:
      Log.error('Unsupported system, using dummy syscalls');
      SysCalls = WebSysCalls;
  }
}
